function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import GeoJSON from 'ol/format/GeoJSON';

/**
 * Trying get GFI JSON
 * @method getGfiJSON
 * @param {Object} data
 * @returns {Object} returns object if data has JSON Object, other null
 */
var getGfiJSON = function getGfiJSON(data) {
  try {
    if (typeof data === 'string') {
      var parsedJSON = JSON.parse(data);

      // Handle non-exception-throwing cases:
      if (parsedJSON && _typeof(parsedJSON) !== 'object' || !parsedJSON) {
        return null;
      }
      return parsedJSON;
    } else if (data && _typeof(data) === 'object') {
      return data;
    }
    return null;
  } catch (e) {}
  return null;
};

/**
 * Checks at if data has GeoJSON
 * @method hasGeoJSON
 * @param {Object} data
 * @returns {Boolean} true if data has GeoJSON Object, other false
 */
var hasGeoJSON = function hasGeoJSON(data) {
  try {
    new GeoJSON().readFeatures(data);
  } catch (e) {
    return false;
  }
  return true;
};

/**
 * Checks at if feature has WMS gfi response
 * @method isWMSgfi
 * @param {Object} feature
 * @returns
 */
var isWMSgfi = function isWMSgfi(feature) {
  return feature.type === 'wmslayer' && ['presentationType', 'content', 'type'].every(function (key) {
    return !!feature[key];
  });
};

/**
 * Gets GFI response type
 * @method getGfiResponseType
 * @param {Object} feature
 * @returns {String} GFI response type (json, geojson or text)
 */
export var getGfiResponseType = function getGfiResponseType(feature) {
  if (isWMSgfi(feature)) {
    var isJSON = getGfiJSON(feature.content);
    if (isJSON) {
      if (hasGeoJSON(feature.content)) {
        return 'geojson';
      }
      return 'json';
    }
    return 'text';
  } else {
    // Content is WFS feature properties
    return 'json';
  }
};

/**
 * Gets GFI content
 * @method getGfiContent
 * @param {Object} feature
 * @returns GFI content
 */
export var getGfiContent = function getGfiContent(feature) {
  var gfiJSON = getGfiJSON(feature.content);
  if (gfiJSON) {
    return gfiJSON;
  } else if (_typeof(feature) === 'object' && !feature.content && feature.content !== '') {
    return feature;
  }
  return feature.content;
};

/**
 * Check at if content has GFI data
 * @method hasGfiData
 * @param {Object} content
 * @param {String} type
 * @returns {Boolean} true if there is GFI content data
 */
export var hasGfiData = function hasGfiData(content, type) {
  var hasStringGfiData = typeof content === 'string' && content !== 'unknown' && content !== '';
  var hasGeoJsonGfiData = type === 'geojson' && content.features && content.features.length > 0;
  var hasJsonGfiData = type === 'json' && content !== '';
  return hasStringGfiData || hasGeoJsonGfiData || hasJsonGfiData;
};